var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81059 12.5C10.4282 12.5 11.7396 11.1569 11.7396 9.5C11.7396 7.84315 10.4282 6.5 8.81059 6.5C7.19295 6.5 5.88159 7.84315 5.88159 9.5C5.88159 11.1569 7.19295 12.5 8.81059 12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81065 1.5C6.73914 1.5 4.75247 2.34285 3.28769 3.84315C1.82291 5.34344 1 7.37827 1 9.5C1 11.392 1.39249 12.63 2.4645 14L8.81065 21.5L15.1568 14C16.2288 12.63 16.6213 11.392 16.6213 9.5C16.6213 7.37827 15.7984 5.34344 14.3336 3.84315C12.8688 2.34285 10.8822 1.5 8.81065 1.5V1.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7ed248edb17b8371376eace52785bb72.svg";
export { ForwardRef as ReactComponent };